import { render } from "./WorkshopStats.vue?vue&type=template&id=e554f6be"
import script from "./WorkshopStats.vue?vue&type=script&lang=js"
export * from "./WorkshopStats.vue?vue&type=script&lang=js"

import "./WorkshopStats.vue?vue&type=style&index=0&id=e554f6be&lang=css"

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__